import { render, staticRenderFns } from "./cartype.vue?vue&type=template&id=8187e87c&scoped=true"
import script from "./cartype.vue?vue&type=script&lang=js"
export * from "./cartype.vue?vue&type=script&lang=js"
import style0 from "./cartype.vue?vue&type=style&index=0&id=8187e87c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8187e87c",
  null
  
)

export default component.exports